import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../lib/api';

const I18nContext = createContext();

const SUPPORTED_LANGUAGES = {
  en: 'English',
  es: 'Español', 
  fr: 'Français'
};

export function I18nProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('reddi_language') || 'en';
  });
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTranslations(language);
  }, [language]);

  const loadTranslations = async (lang) => {
    try {
      setLoading(true);
      const response = await api.get(`/i18n/translations/${lang}`);
      setTranslations(response.data.translations || {});
    } catch (error) {
      console.error('Failed to load translations:', error);
      // Fallback to empty translations
      setTranslations({});
    } finally {
      setLoading(false);
    }
  };

  const changeLanguage = async (newLang) => {
    if (newLang === language) return;
    
    setLanguage(newLang);
    localStorage.setItem('reddi_language', newLang);
    
    // Try to save preference to backend if logged in
    try {
      const token = localStorage.getItem('token');
      if (token) {
        await api.put('/i18n/preference', null, { params: { language: newLang } });
      }
    } catch (error) {
      // Silently fail - preference saved locally
    }
  };

  const t = (key, fallback) => {
    return translations[key] || fallback || key;
  };

  return (
    <I18nContext.Provider value={{
      language,
      setLanguage: changeLanguage,
      t,
      translations,
      loading,
      supportedLanguages: SUPPORTED_LANGUAGES
    }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
}

export default I18nContext;
